// 隐藏信息
export const getEllipsis = (val, symbol, m, n) => {
  if(!val) {
    return ''
  }
  if(m === 'front') {
    const end = val.substr(-n)
    return symbol + end
  } else {
    const start = val.substr(0, m)
    const end = n ? val.substr(-n) : ''
    return start + symbol + end
  }
}

// 保留小数位
export const getFloat = (val, num = 2) => {
  if(val === undefined) return ''
  if (!Number(num)) {
    num = 2
  }
  val = val + ''
  if (!val) {
    val = 0
    val = parseFloat(val).toFixed(num);
  }
  const i = val.indexOf('.')
  switch(num){
    case 4:
      if(i < 0) {
        val = val + '.0000'
      } else {
        val = val.substring(0, i + 5)
      }
      break;
    case 8:
      if(i < 0) {
        val = val + '.00000000'
      } else {
        val = val.substring(0, i + 9)
      }
      break;
    default:
      if(i < 0) {
        val = val + '.00'
      } else {
        val = val.substring(0, i + 3)
      }
      break;
  }
  return val;
}